import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { ErrorsExpansionPanelModule } from '@portal-core/general/components/errors-expansion-panel/errors-expansion-panel.module';
import { LiveLogComponent } from './live-log.component';

@NgModule({
  declarations: [LiveLogComponent],
  imports: [CommonModule, ErrorsExpansionPanelModule, MatButtonModule, MatIconModule, MatProgressBarModule, MatTooltipModule, RouterModule, ScrollingModule],
  exports: [LiveLogComponent]
})
export class LiveLogModule {}
